<template>
  <el-select :size="size" placeholder="区域类型" style="width: 120px;margin-right: 10px" @change="changeStudentType"
             v-model="studentType">
    <div>
      <el-option label="全部" :value="null"></el-option>
      <el-option label="中招体育" value="1"></el-option>
      <el-option label="少年" value="2"></el-option>
      <el-option label="高考体育" value="4"></el-option>
      <el-option label="幼儿" value="5"></el-option>
    </div>

  </el-select>
  <el-cascader
      ref="cascader"
      :size="size"
      style="margin-right: 10px;width: 320px;"
      placeholder="请选择区域(可搜索)"
      :options="treeList"
      collapse-tags
      :collapse-tags-tooltip="true"
      clearable
      filterable
      :filter-method="areaFilterMethod"
      @change="changeArea"
      :props="{
        multiple: multipleStatus
        ,value: 'id'
        ,label: 'name'
        ,children: 'children'}"/>
</template>

<script>
import {listAreaTreeAddCoach} from "@/api/area.js";

export default {
  name: "SelectArea",
  props: {
    //是否限制 选中数量
    size: String,
    //是否监听单个点击变化
    clear: String,
    //是否可多选
    multipleStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      //树状区域列表集合
      treeList: [],
      //选中的 区域ID集合
      treeCheckAreaId:[],
      //当前点击的节点areaId
      nowCheckAreaId: [],
      // sysStudentType:localStorage.getItem('studentType'),
      //flag中招/少年/高考/幼儿
      studentType: null
    }
  },
  methods: {
    // 切换flag类型
    changeStudentType(val) {
      this.$emit('Flag', val)
      // console.log(val)
      //切换flag对应的区域数据
      this.getAreaList(val);
    },
    changeArea(val) {
      // 处理真正勾选的节点
      let trueSelectedNodes = this.getTrueSelectedNodes(val, this.treeList);
      console.log('真正勾选的管辖区域节点:', trueSelectedNodes);
      //当前点击的区域的id
      this.nowCheckAreaId = val;


      //如果是可多选的
      if (this.multipleStatus === true) {
        //原有的方式
        // let areaListId = [];
        //遍历
        // val.forEach(function (item) {
        //   areaListId.push(...item)
        // })
        //传入区域ID
        // this.$emit('areaListId', areaListId)
        console.log("进了多选")
        this.$emit('areaListId', trueSelectedNodes)
      } else {
        //如果是单选的
        console.log("进了单选")
        this.$emit('areaListId', val == null ? null : val[val.length - 1])
      }

    },

    // 区域/校区模糊筛选：支持输入区域名或校区名，忽略大小写与首尾空格
    // node.text 为完整路径（如 "金水区 / 花园路校区"），因此输入区域名可匹配其下全部校区，输入校区名可精确命中
    areaFilterMethod(node, keyword) {
      const kw = (keyword || '').toString().trim().toLowerCase();
      if (!kw) return true;
      return (node.text || '').toLowerCase().includes(kw);
    },

    //获取真实选中的节点 返回真实选中数组
    getTrueSelectedNodes(selectedValues, options) {
      console.info(selectedValues)
      console.info(options)
      //查找前清空
      this.trueSelectOptions = [];
      //获取真实选中
      this.checkValidity(options, selectedValues)
      //返回真实选中节点
      return this.trueSelectOptions;
    },
    //获取真实选中节点 返回状态
    checkValidity(tree, validList) {
      //多维数组扁平化处理
      const flatValidList = validList.flat();
      //遍历树状数据
      return tree.map(node => {
        // console.info(node);
        //当前节点是否有效勾选--此处和自定义的value 有所区别,此处使用的value是id
        // let isValid = flatValidList.includes(node.value);
        let isValid = flatValidList.includes(node.id);

        if (node.children) {
          // 递归检查子节点
          const childValid = this.checkValidity(node.children, validList);
          // 判断所有子节点必须有效
          const allChildrenValid = childValid.every(valid => valid.isValid);
          // 判断若任意节点无效
          const anyChildInvalid = childValid.some(valid => !valid.isValid);

          // 如果所有子节点有效，当前节点有效；如果有任意子节点无效，当前节点无效
          isValid = isValid && allChildrenValid && !anyChildInvalid;
        }

        // console.log(`${node.label}: ${isValid ? '有效' : '无效'}`);
        //确定节点有效 才加入到真实选择
        if (isValid) {
          //和自定义树状数据 有所区别
          // this.trueSelectOptions.push(node.value)
          //查看返回的name以测试 是否是按照规则返回的
          // this.trueSelectOptions.push(node.name)
          this.trueSelectOptions.push(node.id)

        }
        // 返回节点的有效性
        return {isValid};
      });
    },

    //初始化 多级数据源area的 树状结构
    getTypeList(commodityType) {
      if (commodityType != null) {
        commodityType.forEach(items => {
          if (items != null) {
            if (items.children != null && items.children.length > 0) {
              this.getTypeList(items.children);
            } else {
              items.children = undefined;
            }
          }
        });
        return commodityType;
      }
    },
    //加载多级数据源
    getAreaList(typeId) {
      const safeTypeId = [null, undefined, '', ''].includes(typeId) ? 'default' : typeId;
      const cacheKey = `listAreaTreeAddCoach_${safeTypeId}`;
      const cache = sessionStorage.getItem(cacheKey);
      if (cache) {
        this.treeList = JSON.parse(cache);
        return;
      }
      //根据传入的flag
      listAreaTreeAddCoach(typeId).then(val => {
        if (val.code == 200) {
          this.getTypeList(val.data);
          this.treeList = val.data;
          sessionStorage.setItem(cacheKey, JSON.stringify(val.data));
        }
      })
    }
  },
  created() {
    //开始加载
    this.getAreaList();
  },
  watch: {
    //若传入的clear有值 则监听器生效
    clear: {
      // immediate: true,
      handler: function (oldVal, newVal) {
        if (oldVal !== newVal) {
          this.$refs.cascader.$refs.panel.clearCheckedNodes();
          this.studentType = null
        }
      },
      deep: true, // 深度监听
    },
  }

}
</script>

<style scoped>

</style>
<style lang="scss">
.el-popover.my-el-popover {
  width: 20px;
}

.el-cascader__tags {
  display: inline-flex;
  margin-right: 60px;
  flex-wrap: nowrap;
}
</style>
